module.exports = __webpack_public_path__ + "images/smartphone-screen-1_b7c883fd255fc936f33dc54b5cd35c28.png";